import { c as _c } from "react/compiler-runtime";
import { MemberAvatars } from "@components/common/member/member-avatars";
import { compareMembersByDefaultName } from "@components/table/members/members-table-utils";
import { projectMembersSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";

/**
 * Shows the details regarding project members
 */
export function MemberDetails() {
  const $ = _c(4);
  const projectMembers = useAppSelector(projectMembersSelector);
  let t0;
  if ($[0] !== projectMembers) {
    t0 = [...projectMembers].sort(_temp);
    $[0] = projectMembers;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const sortedProjectMembers = t0;
  let t1;
  if ($[2] !== sortedProjectMembers) {
    t1 = <MemberAvatars label="Project Members" members={sortedProjectMembers} maxMemberAvatars={4} />;
    $[2] = sortedProjectMembers;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp(a, b) {
  return compareMembersByDefaultName(a, b, "ascending");
}